import MacheteController from '../controller';

export const getModel = () => MacheteController.instance.model;
export const getSavedModel = () =>
  MacheteController.instance.models.saved.model;
export const setSavedModel = (model) => {
  MacheteController.instance.models.saved =
    MacheteController.instance.models.saved || {};
  MacheteController.instance.models.saved.model = model;
};
export const getOriginalModel = () =>
  MacheteController.instance.models.original.model;

export default {
  getModel,
  getSavedModel,
  setSavedModel,
  getOriginalModel,
};
